const PHONE_REGEX = /^03\d{8}$/;

/**
 * Vérifie si un numéro est valide (format malgache 03xxxxxxxx).
 * @param {string} value
 * @param {boolean} allowEmpty - si true, une valeur vide est considérée valide (pas d'erreur affichée)
 */
export const isPhoneValid = (value, allowEmpty = false) => {
  const cleaned = (value || "").replace(/\s/g, "");
  if (!cleaned) return allowEmpty;
  return PHONE_REGEX.test(cleaned);
};

/**
 * Filtre une saisie de numéro : ne garde que des chiffres, limite à 10 chiffres,
 * et force le préfixe "03" dès les 2 premiers chiffres.
 * @param {string} raw
 * @returns {string} valeur filtrée à utiliser dans le champ
 */
export const filterPhoneInput = (raw) => {
  let digitsOnly = (raw || "").replace(/\D/g, "").slice(0, 10);

  if (digitsOnly.length >= 1 && digitsOnly[0] !== "0") {
    digitsOnly = "0" + digitsOnly.slice(0, 9);
  }
  if (digitsOnly.length >= 2 && digitsOnly[1] !== "3") {
    digitsOnly = digitsOnly[0] + "3" + digitsOnly.slice(2, 9);
  }

  return digitsOnly;
};

export const PHONE_ERROR_MESSAGE = "Numéro invalide. Format attendu : 03xxxxxxxx";